module.exports = __webpack_public_path__ + "img/egg-1.b4b6c6a7.svg";